/* eslint-disable */
import React from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Members/MemberListCard.style.css";
import PropTypes from "prop-types";

const MemberListCard = ({ image, name, profileId, address }) => {
  const cardClickHandel = ({ name, image, profileId, address }) => {
    console.log(name, image, profileId, address);
  };
  return (
    <li className="memberListCard">
      <button
        onClick={() => cardClickHandel({ name, image, profileId, address })}
      >
        <div className="memberListCardPersonalInformationContainer">
          <img src={image} alt="Profile Image" />
          <div className="memberListCardProfileDetails">
            <h3>{name}</h3>
            <span>ID: {profileId}</span>
          </div>
        </div>
        <div className="memberListCardUserAddress">{address}</div>
      </button>
    </li>
  );
};

export default MemberListCard;

MemberListCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
};
